import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
    OpportunityDashboardFilters,
    OpportunityDashboardSearchFields,
    OpportunityDashboardView,
    OpportunityDashboardViews,
} from "models/opportunity-dashboard"
import FiscalCalendar from "utils/fiscal-calendar"

// Each tab is loaded the first time it is opened, and again when the filters change.
export interface OpportunityDashboardSliceState {
    filters: OpportunityDashboardFilters
    searchFields: OpportunityDashboardSearchFields | null
    views: OpportunityDashboardViews
    loadedFor: Partial<Record<OpportunityDashboardView, string>> // filtersKey each view was loaded for
    isLoading: boolean
}

export const emptyFilters = (fiscalYear: number): OpportunityDashboardFilters => ({
    fiscalYear,
    divisionIds: [],
    departmentIds: [],
    branchIds: [],
    months: [],
    search: "",
})

const initialState: OpportunityDashboardSliceState = {
    filters: emptyFilters(FiscalCalendar.currentFiscalYear()),
    searchFields: null,
    views: {},
    loadedFor: {},
    isLoading: false,
}

const OpportunityDashboardSlice = createSlice({
    name: "OpportunityDashboard",
    initialState,
    reducers: {
        setOpportunityDashboardFilters(state, action: PayloadAction<OpportunityDashboardFilters>) {
            state.filters = action.payload
        },
        setOpportunityDashboardSearchFields(state, action: PayloadAction<OpportunityDashboardSearchFields | null>) {
            state.searchFields = action.payload
        },
        setOpportunityDashboardView(state, action: PayloadAction<{ view: OpportunityDashboardView; key: string; data: any }>) {
            (state.views as any)[action.payload.view] = action.payload.data
            state.loadedFor[action.payload.view] = action.payload.key
        },
        setOpportunityDashboardLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
    },
})

export const {
    setOpportunityDashboardFilters,
    setOpportunityDashboardSearchFields,
    setOpportunityDashboardView,
    setOpportunityDashboardLoading,
} = OpportunityDashboardSlice.actions

export default OpportunityDashboardSlice.reducer
